var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6204,
    cy: 19,
    rx: 19.6204,
    ry: 19,
    fill: "#4F4E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0431 19.4L9.14307 15.5L13.0431 11.6L16.9431 15.5L13.0431 19.4ZM16.5431 29V24C15.5264 23.9167 14.5181 23.7957 13.5181 23.637C12.5181 23.4783 11.5264 23.266 10.5431 23L11.0431 21C12.4431 21.3833 13.8474 21.646 15.2561 21.788C16.6647 21.93 18.0937 22.0007 19.5431 22C20.9931 22 22.4224 21.929 23.8311 21.787C25.2397 21.645 26.6437 21.3827 28.0431 21L28.5431 23C27.5597 23.2667 26.5681 23.4793 25.5681 23.638C24.5681 23.7967 23.5597 23.9173 22.5431 24V29H16.5431ZM19.5431 14C18.7097 14 18.0014 13.7083 17.4181 13.125C16.8347 12.5417 16.5431 11.8333 16.5431 11C16.5431 10.1667 16.8347 9.45833 17.4181 8.875C18.0014 8.29167 18.7097 8 19.5431 8C20.3764 8 21.0847 8.29167 21.6681 8.875C22.2514 9.45833 22.5431 10.1667 22.5431 11C22.5431 11.8333 22.2514 12.5417 21.6681 13.125C21.0847 13.7083 20.3764 14 19.5431 14ZM19.5431 21C18.9931 21 18.5221 20.804 18.1301 20.412C17.7381 20.02 17.5424 19.5493 17.5431 19C17.5431 18.45 17.7391 17.979 18.1311 17.587C18.5231 17.195 18.9937 16.9993 19.5431 17C20.0931 17 20.5641 17.196 20.9561 17.588C21.3481 17.98 21.5437 18.4507 21.5431 19C21.5431 19.55 21.3471 20.021 20.9551 20.413C20.5631 20.805 20.0924 21.0007 19.5431 21ZM24.5931 19L22.8931 16L24.5931 13H27.9931L29.6931 16L27.9931 19H24.5931Z",
    fill: "#ADACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.a9c415311e696332dab8f7d63a56db11.svg";
export { ForwardRef as ReactComponent };